import { ProgramTypeText } from '@/ts/common-types';
import { ICellRendererParams } from 'ag-grid-community';

const ProgramTypeCellRenderer = (params: ICellRendererParams) => {
    const typeText = params.data[params.colDef.field];
    return (
        <>
            {
                ProgramTypeText[typeText as keyof typeof ProgramTypeText]
            }
        </>
    )
}

export default ProgramTypeCellRenderer;